import _ from 'underscore';
import i18n from '../i18n';

import View from './view';

import { hashify } from '../utils/arrays';
import { flatify } from '../model/refbooks/field.utils';





let ifn; i18n.then( i => ifn = i );

export default View.extend( {
    
    initialize(options = {}) {
        this.gather = options.gather || this.gather;
        
        View.prototype.initialize.apply( this, arguments );
    },
    
    events: {
        
        'keyup textarea': function(e) {
            if (13 === e.keyCode)
                e.stopPropagation();
        }
        
    },
    
    validate() {
        const fl = fields => flatify( fields )
            .filter( field => field.default_value != undefined && field.default_value != '' )
        const defvals = hashify( 
            fl( this.options.fields ),
            ({ translit, format, default_value }) => [
                translit, 
                format === 'bool' ? default_value === 'true' : default_value] );

        const take = ([prop, ...rest], here = this.model.get( 'fields' ) || {}) => {
            if (here == undefined)
                return here; // null -> null, undefined -> undefined

            if (!prop)
                return typeof here == 'object'
                    ? here.values // Data-Table with values
                    : here;       // Any other type of Custom field

            if (!here[prop])
                return undefined;

            return here instanceof Array
                ? take( rest, here[prop] )        // Composite[index]
                : take( rest, here[prop].value ); // Any other type of Custom field
        };

        const val = name => {
            const path = name.split( /\.|\[|\]/ )
                .map( s => decodeURIComponent( s ).replaceAll( '[dot]', '.' ) )
                .filter( s => s.length );
            const value = take( path );
            return value
                ? value
                : path.length === 1 ? this.model.get( name ) : value;
        };

        const messages = [...this.$( '[required]:not([disabled]):visible' )]
            .map( el => this.$( el ) )
            .filter( $el => 
                $el.closest( '.disabled' ).length == 0 && 
                $el.closest( '[disabled]' ).length == 0 )
            .map( $el => {
                const path = $el.attr( 'name' );
                const [translit] = path.split( '.' ).reverse();

                const value = val( path );
                return value !== undefined
                    ? [value, $el]
                    : [defvals[translit], $el];
            } )
            .filter( ([value]) => 
                value == undefined ||
                value === '' || 
                value instanceof Array && value.length === 0 ||
                typeof value === 'boolean' && !value )
            .map( ([value, $el]) => [ifn( 'forms::required field' ), $el[0], value] )

        return { 
            result: console.log( messages ) || messages.length === 0, 
            messages
        };
    },

    commit() {
        this.originalModel = this.model.clone();
    },

    rollback() {
        this.model.set( this.originalModel.toJSON() );
    },

    diff(options = {}) {
        return this.model
            ? this.model.diff( this.originalModel, options )
            : [];
    },

    hasDiff(options = {}) {
        return this.diff( options ).length > 0;
    }
   
} );


// WEBPACK FOOTER //
// ./src/js/view/form.js